import { UseFormMethods, useWatch } from "react-hook-form";
import { ICancelBroadbandForm } from "@features/CancelBroadband/interface/ICancelBroadbandForm";
import { useGetTerminationReasons } from "@modules/accounts/swr";
import { EServiceGroup } from "@pages/AccountDetails/interface/IAccountDetailsPage";
import { useEffect } from "react";

export const useCancelBroadbandReasons = (
    cancelBroadbandForm: UseFormMethods<ICancelBroadbandForm> & Partial<UseFormMethods>
) => {
    const primaryReasonListState = useGetTerminationReasons(EServiceGroup.SA_BB);

    const primaryReasonValue = useWatch<string>({
        control: cancelBroadbandForm.control,
        name: "primaryReason",
    });

    useEffect(() => {
        cancelBroadbandForm.setValue("secondaryReason", null);
    }, [primaryReasonValue]);

    return { primaryReasonListState, primaryReasonValue };
};
